<template>
  <div  class="flex flex-wrap -mx-2 text-sm items-stretch">
    <div v-if="!showEditpage" class="flex-1 w-full px-4">
      <h1 slot="header" class="w-full text-lg py-4">
        Staff &amp; Associated Offices
      </h1>
      <div v-if="system.external_data.bios === true && system.external_data.reduced_bios === false" class="w-full pb-6">
        Below are all the registered staff members that you have access to and can appoint to the 'Meet the team' page on the Fine &amp; Country website. In order to ensure a Profile is presented on fineandcountry.com, you must select at least one office in the 'Visibility' column. Profiles which state 'Not Visible on Office pages' are not presented on fineandcountry.com.
      </div>
      <div v-else class="w-full pb-6">
        Below are all the registered staff members that you have access to.
      </div>
      <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
        <div class="w-full lg:w-1/4 px-2 mb-4">
          <label for="search_text" class="text-sm">Search:</label>
          <input type="search_text" id="search_text" v-model="searchValue" class="w-5/6 block border hover:border-grey focus:border-grey-dark p-2 mt-2 mr-8 h-10 text-sm" placeholder="Search by first name">
        </div>
        <div class="w-full lg:w-1/4 px-2 mb-4">
          <label for="offices" class="text-sm">Office:</label>
          <select id="offices" v-model="searchOffice" @change="getPagenatedUsers()" class="block w-full border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm w-3/4">
            <option value="all" selected>All</option>
            <option v-for="selecteOffice in office_list" :key="selecteOffice.id" :value="selecteOffice.id">{{selecteOffice.name}} ({{selecteOffice.town}})</option>
          </select>
        </div>
        <div class="flex w-1/2 px-2 mb-4 justify-end items-end">
          <button class="bg-grey-light text-sm rounded hover:bg-grey flex items-center justify-center px-6 h-12" @click="showUserCreateModal = true">
          <icon name="new_user" class="h-12 w-12 mr-4" :center="false"></icon>
            Add New Staff Member
          </button>
        </div>
      </div>
      <loader v-if="loadingUser" class="mt-6" />
      <div class="w-full" v-else>
        <table class="w-full">
          <thead>
          <tr class="text-sm align-top">
            <th class="py-5 uppercase">First name
              <i v-if="sorting.first_name==='asc'" class="fa fa-sort-down  cursor-pointer" @click="sortBy('first_name', 'asc')"></i>
              <i v-else-if="sorting.first_name==='desc'" class="fa fa-sort-up cursor-pointer" @click="sortBy('first_name', 'desc')"></i>
              <i v-else class="fa fa-sort cursor-pointer" @click="sortBy('first_name', 'asc')"></i>
            </th>
            <th class="py-5 uppercase">Surname
              <i v-if="sorting.surname==='asc'" class="fa fa-sort-down  cursor-pointer" @click="sortBy('surname', 'asc')"></i>
              <i v-else-if="sorting.surname==='desc'" class="fa fa-sort-up cursor-pointer" @click="sortBy('surname', 'desc')"></i>
              <i v-else class="fa fa-sort cursor-pointer" @click="sortBy('surname', 'asc')"></i>
            </th>
            <th class="py-5 uppercase">Position
              <i v-if="sorting.position==='asc'" class="fa fa-sort-down  cursor-pointer" @click="sortBy('position', 'asc')"></i>
              <i v-else-if="sorting.position==='desc'" class="fa fa-sort-up cursor-pointer" @click="sortBy('position', 'desc')"></i>
              <i v-else class="fa fa-sort cursor-pointer" @click="sortBy('position', 'asc')"></i>
            </th>
            <th v-if="network === 'guild'" class="py-5 uppercase">Email
              <i v-if="sorting.email==='asc'" class="fa fa-sort-down  cursor-pointer" @click="sortBy('email', 'asc')"></i>
              <i v-else-if="sorting.email==='desc'" class="fa fa-sort-up cursor-pointer" @click="sortBy('email', 'desc')"></i>
              <i v-else class="fa fa-sort cursor-pointer" @click="sortBy('email', 'asc')"></i>
            </th>
            <th v-if="system.external_data.bios === true" class="py-5 uppercase"> Website Visibility
              <i v-if="sorting.associated_office==='asc'" class="fa fa-sort-down  cursor-pointer" @click="sortBy('associated_offices_text', 'asc')"></i>
              <i v-else-if="sorting.associated_office==='desc'" class="fa fa-sort-up cursor-pointer" @click="sortBy('associated_offices_text', 'desc')"></i>
              <i v-else class="fa fa-sort cursor-pointer" @click="sortBy('associated_office', 'asc')"></i>
                <i class="tooltip-container fas fa-info-circle text-blue ml-2">
                  <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                    <span v-if="system.external_data.bios === true && system.external_data.reduced_bios === true" class="text-black font-sans">In order to ensure a Profile is presented on fineandcountry.com, you must select at least one office in the 'Visibility' column. Profiles which state 'Not Visible on Office pages' are not presented on website.</span>
                    <span v-else class="text-black font-sans">In order to ensure a Profile is presented on fineandcountry.com, you must select at least one office in the 'Visibility' column. Profiles which state 'Not Visible on Office pages' are not presented on fineandcountry.com.</span>
                  </div>
                </i>
            </th>
            <th class="py-5 uppercase" v-if="network === 'fc'">Website Status</th>
            <th class="py-5 uppercase">Access Level
              <i v-if="sorting.admin_access==='asc'" class="fa fa-sort-down  cursor-pointer" @click="sortBy('admin_access', 'asc')"></i>
              <i v-else-if="sorting.admin_access==='desc'" class="fa fa-sort-up cursor-pointer" @click="sortBy('admin_access', 'desc')"></i>
              <i v-else class="fa fa-sort cursor-pointer" @click="sortBy('admin_access', 'asc')"></i>
            </th>
            <th v-if="network === 'guild' || network === 'fc'" class="py-5 uppercase">Referral<br>System</th>
            <th  class="py-5 uppercase" v-if="network === 'guild'">Learning Platform</th>
            <th class="py-5 uppercase">Edit</th>
            <th class="py-5 uppercase">Delete</th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="user in filterdUser" :key="user.id" class="border text-xs md:text-sm border-l-4 border-r-4 text-center">
            <td class="p-5 font-bold">{{ user.first_name }}</td>
            <td class="p-5 font-bold">{{ user.surname }}</td>
            <td class="p-5">{{ user.position }}</td>
            <td v-if="network === 'guild'" class="p-5">{{ user.email }}</td>
            <td v-if="system.external_data.bios === true"><pop-over :userAssociatedText="user.associated_offices_text" :popUpUser="user"></pop-over></td>
            <td  v-if="network === 'fc'">
              <div v-if="user.userApproval">
                <span v-if="user.userApproval.status === 1">Profile Approved</span>
                <span v-else-if="user.userApproval.status === 2">Profile Rejected</span>
                <span v-else-if="user.userApproval.status === 0">Profile Pending Approval</span>
                <span v-else-if="user.userApproval.status === 3 || !user.userApproval.status">Not Yet Submitted</span>
                <span v-else>-</span>
              </div>
              <div v-else>-</div>
            </td>
            <td class="p-5">{{ user.admin_access }}</td>
            <td v-if="network === 'guild' || network === 'fc'" class="p-5"><i v-if="user.referral_system" class="fa fa-check text-green"></i></td>
            <td class="p-5" v-if="network === 'guild'">
              <span v-if="user.moodleEnrolments.length === 0">N/A</span>
              <span class="ml-1 cursor-pointer" v-for="moodleEnrolment in user.moodleEnrolments" :key="moodleEnrolment.id">
                <pop-over-staff :userAssociatedText="moodleEnrolment.acronym" :popUpUser="moodleEnrolment" :scrollX="false"></pop-over-staff>
              </span>
            </td>
            <td v-if="profile_v2.id === user.id" class="p-5 items-center">
              <button @click="$emit('editFromProfile')" ><icon :center="false" name="edit-information" class="h-8 w-8"></icon></button>
            </td>
            <td v-else class="p-5 items-center">
              <button v-if="profile_v2.type <= user.type" @click="EditUser(user)"><icon :center="false" name="edit-information" class="h-8 w-8"></icon></button>
              <button v-else ><icon :center="false" name="edit-information-locked" class="h-8 w-8" ></icon></button>
            </td>
            <td class="p-5"><button :disabled="profile_v2.type > user.type" @click="deleteUserModal = user"><icon :center="false" name="close_small" class="h-8 w-8"></icon></button></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
     <deletion-modal
      v-if="deleteUserModal"
      @confirmed="deleteUser(deleteUserModal)"
      @leave="deleteUserModal = null"
      @dismissed="deleteUserModal = null">
      <p class="text-center">Are you sure you wish to delete <strong>{{deleteUserModal.name}} </strong>?</p>
    </deletion-modal>
    <modal
      v-if="showUserCreateModal"
      :scrollY="false"
      @leave="showUserCreateModal = null"
      v-on:ChangeView="showUserCreateModal = null"
      :showCloseBtn="true"
    >
    <user-create @user-created="openCreatedUser"></user-create>
    </modal>
    <user-edit v-if="showEditpage" :user="clickedUser" :network="network" class="w-full" @close-edit="reloadUser()" @reload-user="reloadUser()"/>
  </div>
</template>

<script>
import api from '@/http'
import Pagination from 'laravel-vue-pagination'
import UserCreate from './UserCreate.vue'
import { mapState, mapActions } from 'vuex'
import UserEdit from './UserEdit.vue'
import PopOver from './PopOver.vue'
import DeletionModal from '@/components/Modals/DeletionModal'
import Icon from '../Icon.vue'
import PopOverStaff from './PopOverStaff.vue'
export default {
  name: 'ProfileStaff',
  components: {
    Pagination,
    UserCreate,
    UserEdit,
    PopOver,
    DeletionModal,
    Icon,
    PopOverStaff
  },
  data () {
    return {
      filters: {},
      loading: false,
      showUserCreateModal: false,
      showEditpage: false,
      loadingUser: true,
      users: [],
      deleteUserModal: false,
      clickedUser: null,
      office_list: [],
      searchOffice: 'all',
      searchValue: '',
      sorting: {
        name: null,
        position: null,
        email: null,
        associated_office: null,
        admin_access: null
      }
    }
  },
  props: ['network'],
  methods:
  {
    ...mapActions([
      'displayToastNotification'
    ]),
    getPagenatedUsers (val) {
      this.loadingUser = true
      var params = {
        client_id: this.selectedOffice.client_id,
        selectedOffice: this.selectedOffice.id
      }
      if (this.searchOffice !== 'all') {
        params.office_id = this.searchOffice
      }
      api.get('/list-user', { params }).then(response => {
        this.users = response.data
        this.loadingUser = false
      }).catch(({ response }) => {
        //
      })
    },
    openCreatedUser (user) {
      this.showUserCreateModal = false
      this.EditUser(user)
    },
    EditUser (user) {
      this.clickedUser = user
      this.showEditpage = true
    },
    reloadUser () {
      this.showEditpage = false
      this.getPagenatedUsers()
    },
    sortBy (by, type) {
      if (type === 'asc') {
        this.sorting[by] = 'desc'
        this.filterdUser = this.filterdUser.sort((a, b) => {
          let fa = a[by].toLowerCase()
          let fb = b[by].toLowerCase()
          if (fa < fb) {
            return -1
          }
          if (fa > fb) {
            return 1
          }
          return 0
        })
      } else {
        this.sorting[by] = 'asc'
        this.filterdUser = this.filterdUser.reverse()
      }
    },
    getOfficeList () {
      var params = {
        office_id: this.selectedOffice.id
      }
      api.get('/office-list', { params }).then(response => {
        this.office_list = response.data
      }).catch(({ response }) => {
        if (response.status === 422) {
        }
      })
    },
    deleteUser (user) {
      api
        .delete(`deleted-user/${user.id}`)
        .then(response => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'User deleted ',
            info: 'Your user has been deleted successfully.'
          })
          this.reloadUser()
          this.deleteUserModal = null
        },
        error => {
          this.errorBag.store(error.response.data)
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'User deleting',
            info: 'Error deleting User.'
          })
        })
    }
  },
  created () {
    this.getPagenatedUsers()
    this.getOfficeList(null)
  },
  computed: {
    ...mapState(['selectedOffice', 'userOfficeList', 'profile_v2', 'system']),

    filterdUser: {
      get: function () {
        let tempUser = this.users
        if (this.searchValue !== '' && this.searchValue) {
          tempUser = tempUser.filter((item) => {
            return item.first_name
              .toUpperCase()
              .includes(this.searchValue.toUpperCase())
          })
        }
        return tempUser
      },
      set: function (newValue) {
        return newValue
      }
    }
  },
  watch: {
    selectedOffice () {
      this.showEditpage = false
      this.getOfficeList(null)
      this.getPagenatedUsers()
    }
  }
}
</script>
